import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// routes
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
// components
import { StyledChart } from "./components/chart";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/css/common.css";
import ScrollToTop from "./components/scroll-to-top";
import { useEffect, useState } from "react";
import USERSROUTES from "src/API_Routes/User/User_Routers";
import { getData } from "./webService/webService";
import Loader from "./utils/CommonLoader/Loader";
import { useSelector } from "react-redux";

// ----------------------------------------------------------------------

export default function App() {
  const LoaderView = useSelector((state) => state?.Loader.View);
  console.log("LoaderView", LoaderView);
  const accessToken = localStorage.getItem("Token");

  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("isAuthenticated") || ""
  );

  useEffect(() => {
    if (!localStorage.getItem("isAuthenticated")) {
      localStorage.setItem("isAuthenticated", isAuthenticated);
    }
  }, [isAuthenticated]);
  const handleLogin = (data) => {
    setIsAuthenticated(data);
    localStorage.setItem("isAuthenticated", data);
  };

  const handleLogout = () => {
    getData(USERSROUTES.SIGNOUT, null, accessToken)
      .then((res) => {
        console.log("Logout successfully");
        setIsAuthenticated(false);
        localStorage.clear();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    setIsAuthenticated(false);
    localStorage.clear();
  };
  return (
    <>
      {LoaderView ? <Loader /> : ""}

      <HelmetProvider>
        <BrowserRouter>
          <ThemeProvider>
            <ScrollToTop />
            <StyledChart />
            <Router
              isAuthenticated={isAuthenticated}
              onLogin={handleLogin}
              onLogout={handleLogout}
            />
          </ThemeProvider>
        </BrowserRouter>
      </HelmetProvider>
    </>
  );
}
